import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AdmisionEntity } from '../../../../../services/servicio-admisiones.service';

@Component({
  selector: 'app-header-admision2',
  templateUrl: './header-admision2.component.html',
  styleUrls: ['./header-admision2.component.css']
})
export class HeaderAdmision2Component implements OnInit {

  loading: boolean;
  downloading: boolean;

  @Input() admision: AdmisionEntity;
  @Output() filtrosSeleccionados: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.onGenerar();
  }

  onGenerar() {
    this.filtrosSeleccionados.emit({});
  }

  onImprimir() {
    const adm = this.admision ? '_' + this.admision.consecutivo : '';
    let printContents: any, popupWin: any;
    var left = (screen.width/2) - (screen.width / 4);
    printContents = document.getElementById('print-admision-2').innerHTML;
    popupWin = window.open('', '_blank', `height=800px,width=1200px,left=${left}`);
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title>Admision${adm}</title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

}
